"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfiniteScroll = void 0;
var react_1 = __importStar(require("react"));
var useEventListener_1 = require("../../../hooks/useEventListener");
exports.InfiniteScroll = react_1.default.forwardRef(function InfiniteScroll(_a, ref) {
    var children = _a.children, scrolledDown = _a.scrolledDown, scrolledUp = _a.scrolledUp, _b = _a.infiniteScrollDistance, infiniteScrollDistance = _b === void 0 ? 200 : _b, rest = __rest(_a, ["children", "scrolledDown", "scrolledUp", "infiniteScrollDistance"]);
    var refEl = react_1.useRef();
    var clientHeight = react_1.useRef(0);
    var scrollHeight = react_1.useRef(0);
    var oldScrollHeight = react_1.useRef(0);
    var lastEvent = react_1.useRef('');
    react_1.useImperativeHandle(ref, function () { return refEl.current; }, []);
    useEventListener_1.useEventListener('scroll', function ($event) {
        scrollHeight.current = $event.target.scrollHeight;
        clientHeight.current = $event.target.clientHeight;
        var scrollPositionDown = $event.target.scrollTop + clientHeight.current;
        if ($event.target.scrollTop === 0) {
            if (lastEvent.current !== 'top' || oldScrollHeight.current !== scrollHeight.current) {
                oldScrollHeight.current = scrollHeight.current;
                lastEvent.current = 'top';
                if (scrolledUp)
                    scrolledUp();
            }
        }
        else if (infiniteScrollDistance >= scrollHeight.current - scrollPositionDown) {
            if (lastEvent.current !== 'bottom' || oldScrollHeight.current !== scrollHeight.current) {
                oldScrollHeight.current = scrollHeight.current;
                lastEvent.current = 'bottom';
                if (scrolledDown)
                    scrolledDown();
            }
        }
        else if (infiniteScrollDistance >= $event.target.scrollTop) {
            if (lastEvent.current !== 'top' || oldScrollHeight.current !== scrollHeight.current) {
                oldScrollHeight.current = scrollHeight.current;
                lastEvent.current = 'top';
                if (scrolledUp)
                    scrolledUp();
            }
        }
        else {
            lastEvent.current = 'idle';
        }
    }, refEl);
    return (react_1.default.createElement("div", __assign({ ref: refEl }, rest), children));
});
//# sourceMappingURL=InfiniteScroll.js.map